(() => {
  const shopify = window.CoolstarShopifyTheme;
  if (!shopify?.routes) return;
  const { routes } = shopify;
  const cartKey = "coolstar_cart_v1";
  const routeByFile = {
    "index.html": routes.root,
    "products.html": routes.products,
    "product-detail.html": `${routes.products}#chips`,
    "cart.html": routes.cart,
    "account.html": routes.account,
    "account-verify.html": routes.accountLogin,
    "500-chip-set.html": routes.pages.set,
    "about.html": routes.pages.about,
    "contact.html": routes.pages.contact,
    "custom.html": routes.pages.custom,
    "wholesale.html": routes.pages.wholesale,
    "shipping.html": routes.pages.shipping,
    "returns.html": routes.pages.returns,
    "privacy.html": routes.pages.privacy,
    "terms.html": routes.pages.terms,
    "my-designs.html": routes.pages.designs,
    "chip-customizer.html": routes.pages.chips,
    "set-customizer.html": routes.pages.sets,
    "poker-supplies-customizer.html": routes.pages.supplies
  };
  const mapLegacyUrl = raw => {
    const categoryRoute=window.CoolstarCategoryRoutes?.rewrite(raw);
    if(categoryRoute&&categoryRoute!==raw)return categoryRoute;
    if (!raw || raw.startsWith("#") || /^(?:https?:|mailto:|tel:|javascript:|data:)/i.test(raw)) return raw;
    let parsed;
    try { parsed = new URL(raw, `${location.origin}/`); } catch { return raw; }
    if (parsed.origin !== location.origin) return raw;
    const filename = decodeURIComponent(parsed.pathname.split("/").pop() || "");
    const categoryFiles = {'poker-sets':routes.pages.categorySets,'poker-chips':routes.pages.categoryChips,'tables-chairs':routes.pages.categoryTables,'poker-supplies':routes.pages.categorySupplies};
    const category = Object.keys(categoryFiles).find(key => filename === key+'.html' || filename.startsWith(key+'-') && filename.endsWith('.html') && !filename.includes('customizer'));
    const mapped = routeByFile[filename] || (category && categoryFiles[category]);
    if (!mapped) return raw;
    const destination = new URL(mapped, location.origin);
    if(category && filename !== category+'.html') destination.searchParams.set('subcategory',filename.slice(category.length+1,-5));
    for (const [key, value] of parsed.searchParams) destination.searchParams.set(key, value);
    if (parsed.hash) destination.hash = parsed.hash;
    return destination.origin === location.origin ? `${destination.pathname}${destination.search}${destination.hash}` : destination.href;
  };
  const rewrite = root => {
    const nodes = [];
    if (root.matches?.("a[href], form[action]")) nodes.push(root);
    nodes.push(...(root.querySelectorAll?.("a[href], form[action]") || []));
    nodes.forEach(node => {
      const attr = node.matches("form") ? "action" : "href";
      const raw = node.getAttribute(attr);
      if (node.matches("form.header-search")) {
        if (raw !== routes.search) node.setAttribute("action", routes.search);
        return;
      }
      const next = mapLegacyUrl(raw);
      if (next && next !== raw) node.setAttribute(attr, next);
    });
  };
  rewrite(document);
  new MutationObserver(records => records.forEach(record => {
    if (record.type === "attributes") rewrite(record.target.parentElement || document);
    else record.addedNodes.forEach(node => { if (node.nodeType === 1) { rewrite(node); if (node.matches?.("a[href],form[action]")) rewrite(node.parentElement || document); } });
  })).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ["href", "action"] });

  const money = cents => new Intl.NumberFormat(undefined, { style: "currency", currency: window.Shopify?.currency?.active || "USD" }).format(Number(cents || 0) / 100);
  let cartRevision = 0;
  const applyCart = cart => {
      const local = cart.items.map(item => ({
        id: String(item.key || item.variant_id), name: item.product_title || item.title,
        price: Number(item.final_price ?? item.price) / 100, qty: Number(item.quantity),
        variant: item.variant_title === "Default Title" ? "" : item.variant_title,
        image: item.image || "", lineTotal: money(item.final_line_price), unitPriceLabel: money(item.final_price ?? item.price)
      }));
      localStorage.setItem(cartKey, JSON.stringify(local));
      window.CoolstarNativeCart.state = cart;
      window.CoolstarNativeCart.totals = { subtotal: money(cart.original_total_price ?? (Number(cart.total_price || 0) + Number(cart.total_discount || 0))), discount: money(cart.total_discount || 0) };
      document.querySelectorAll("[data-cart-count]").forEach(node => { node.textContent = String(cart.item_count || 0); });
      window.dispatchEvent(new Event("shopify:cart:changed"));
      renderDiscountCart(cart);
      return cart;
  };
  const syncCart = async () => {
    const revision = ++cartRevision;
    try {
      const response = await fetch(`${routes.cart}.js`, { headers: { Accept: "application/json" }, credentials: "same-origin" });
      if (!response.ok) return;
      const cart = await response.json();
      if (revision === cartRevision) return applyCart(cart);
    } catch { /* Shopify cart remains available through the Liquid cart and checkout forms. */ }
  };
  const mutateCart = async (url, body) => {
    ++cartRevision;
    const response = await fetch(url, { method: "POST", credentials: "same-origin", headers: { Accept: "application/json", "Content-Type": "application/json" }, body: JSON.stringify(body) });
    const cart = await response.json().catch(() => ({}));
    if (!response.ok) { await syncCart(); throw new Error(cart.description || cart.message || "The cart could not be updated. Please try again."); }
    if (!Array.isArray(cart.items)) throw new Error("The cart response could not be read. Please try again.");
    return applyCart(cart);
  };
  window.CoolstarNativeCart = {
    changeLine: (key, quantity) => mutateCart(routes.cartChange, { id: String(key), quantity: Math.max(0, Math.floor(Number(quantity))) }),
    clear: () => mutateCart(`${routes.root}cart/clear.js`, {})
  };
  const addCartJson = async (variantId, quantity, properties) => {
    const response = await fetch(routes.cartAdd, {
      method: "POST", credentials: "same-origin", headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity || 1), properties }] })
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(result.description || result.message || "This item could not be added. Check its Shopify availability and variant setup.");
    return result;
  };
  const quoteUrl = (setName = "") => {
    const target = new URL(routes.pages.wholesale, location.origin);
    if (setName) target.searchParams.set("set", setName);
    target.hash = "wholesale-form";
    return target.href;
  };
  const featuredVariants = [...document.querySelectorAll("[data-featured-set-variants] option")];
  const setCountFromTitle = title => (String(title || "").match(/\d[\d,]*/g) || []).map(value => value.replace(/,/g, ""));
  const updateFeaturedSet = count => {
    if (!document.querySelector("[data-set-cta]")) return;
    const option = featuredVariants.find(item => setCountFromTitle(item.textContent).includes(String(count)));
    document.querySelectorAll("[data-set-cta]").forEach(button => {
      if (option) {
        button.hidden = false;
        button.dataset.variantId = option.value;
        button.dataset.name = option.textContent.trim();
      } else {
        button.hidden = true;
        delete button.dataset.variantId;
      }
    });
    document.querySelectorAll("[data-set-fallback]").forEach(link => {
      link.hidden = Boolean(option);
      if (!option) link.href = document.body.dataset.page === "landing" ? quoteUrl(`${count}-piece poker set`) : `${routes.pages.set}${routes.pages.set.includes("?") ? "&" : "?"}count=${encodeURIComponent(count)}`;
    });
    if (option?.dataset.price) {
      document.querySelectorAll("[data-set-price]").forEach(node => { node.textContent = option.dataset.price; delete node.dataset.usdPrice; });
      document.querySelectorAll("[data-set-price-note]").forEach(node => { node.textContent = "Shopify product price · final taxes and shipping at checkout"; });
    }
  };
  if (document.querySelector("[data-set-cta]")) {
    const activeTab = document.querySelector("[data-set-option][aria-pressed='true']") || document.querySelector("[data-set-option]");
    if (activeTab) updateFeaturedSet(activeTab.dataset.setOption);
    document.querySelectorAll("[data-set-option]").forEach(tab => tab.addEventListener("click", () => window.setTimeout(() => updateFeaturedSet(tab.dataset.setOption), 160)));
  }
  const showFailure = (form, message) => {
    const status = form?.querySelector(".customizer-save-status, .chip-price-note, [role='status']") || document.querySelector("#chip-save-status");
    if (status) { status.textContent = message; status.classList.add("is-error"); }
  };
  const refreshAndGo = async (button, goToCart) => {
    await syncCart();
    if (goToCart) { location.href = routes.cart; return; }
    if (button) {
      button.classList.add("added");
      button.innerHTML = "Added to cart <span aria-hidden=\"true\">✓</span>";
      window.setTimeout(() => { button.classList.remove("added"); }, 1800);
    }
  };
  document.addEventListener("click", async event => {
    const button = event.target.closest?.("[data-add-to-cart], [data-buy-now]");
    if (!button) return;
    if (button.hasAttribute("data-shopify-add")) { event.stopImmediatePropagation(); return; }
    if (button.dataset.quoteSet) {
      event.preventDefault(); event.stopImmediatePropagation(); location.href = quoteUrl(button.dataset.quoteSet); return;
    }
    const variantId = button.dataset.variantId;
    if (!variantId) {
      event.preventDefault(); event.stopImmediatePropagation();
      location.href = quoteUrl(button.dataset.name || "Poker product");
      return;
    }
    event.preventDefault(); event.stopImmediatePropagation();
    if (button.dataset.busy === "true") return;
    button.dataset.busy = "true";
    const oldContent = button.innerHTML;
    button.disabled = true;
    try {
      const quantity = button.dataset.quantity || document.querySelector("#retail-quantity")?.value || 1;
      await addCartJson(variantId, quantity, {});
      await refreshAndGo(button, button.hasAttribute("data-buy-now"));
    } catch (error) {
      button.innerHTML = oldContent;
      showFailure(button.closest("form"), error.message);
      window.alert(error.message);
    } finally {
      button.disabled = false;
      delete button.dataset.busy;
    }
  }, true);

  document.addEventListener("submit", async event => {
    const form = event.target;
    const submitter = event.submitter;
    if (!form?.matches?.("#chip-customizer-form") || !submitter?.hasAttribute("data-shopify-add")) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const variant = submitter.dataset.variantId || form.querySelector("[data-chip-variant-tiers]")?.value;
    if (!variant) { showFailure(form, "For online checkout, select a custom-chip Shopify product with a variant for this quantity range. You can still save this design or request a quote."); return; }
    submitter.disabled = true;
    const body = new FormData();
    body.append("id", variant);
    body.append("quantity", form.querySelector('[name="quantity"]')?.value || "100");
    const labels = {
      designName: "Design name", shape: "Shape", edgePattern: "Edge pattern", chipInsert: "Chip insert",
      emboss: "Surface", outerColor: "Outer color", innerColor: "Inner color", rimColor: "Rim color",
      artStyle: "Artwork style", frontValue: "Front denomination", frontMark: "Front center mark",
      frontTop: "Front top title", frontBottom: "Front bottom title", frontLeft: "Front left motif",
      frontRight: "Front right motif", backValue: "Back denomination", backMark: "Back center mark",
      backTop: "Back top title", backBottom: "Back bottom title", backLeft: "Back left motif",
      backRight: "Back right motif", textColor: "Text color", font: "Font", fontSize: "Text size"
    };
    for (const field of form.elements) {
      if (!field.name || field.name === "id" || field.name === "quantity" || field.disabled) continue;
      if (field.type === "file") continue;
      if (field.type === "checkbox") {
        if (field.checked) body.append(`properties[${labels[field.name] || field.name}]`, "Yes");
        continue;
      }
      if (field.type === "submit" || field.type === "button" || field.type === "range") continue;
      body.append(`properties[${labels[field.name] || field.name}]`, field.value);
    }
    // Saved designs store compressed data URLs in localStorage. Recreate those
    // files here so artwork is still attached when a customer restores a draft.
    const images = window.CoolstarChipCustomizer?.getImages?.() || {};
    const files = [];
    Object.entries(images).forEach(([side, imageSet]) => {
      Object.entries(imageSet || {}).forEach(([kind, dataUrl]) => {
        if (!dataUrl || !/^data:image\/(?:jpeg|png|webp);base64,/i.test(dataUrl)) return;
        const [metadata, encoded] = dataUrl.split(",", 2);
        const mime = metadata.match(/^data:(image\/[\w.+-]+);base64$/i)?.[1] || "image/jpeg";
        const binary = atob(encoded);
        const bytes = new Uint8Array(binary.length);
        for (let index = 0; index < binary.length; index += 1) bytes[index] = binary.charCodeAt(index);
        const names = { artwork: "artwork", left: "left motif artwork", right: "right motif artwork" };
        files.push({ name: `properties[${side === "back" ? "Back" : "Front"} ${names[kind] || kind}]`, file: new File([bytes], `${side}-${kind}.jpg`, { type: mime }) });
      });
    });
    files.forEach(({ name, file }) => body.append(name, file));
    try {
      const response = await fetch(routes.cartAdd, { method: "POST", credentials: "same-origin", headers: { Accept: "application/json" }, body });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.description || result.message || "The custom chip could not be added. Check the product's tier variants and file upload settings.");
      await syncCart();
      location.href = routes.cart;
    } catch (error) { showFailure(form, error.message); window.alert(error.message); submitter.disabled = false; }
  }, true);

  const codeForm = document.querySelector("[data-shopify-discount-form]");
  const codeInput = codeForm?.querySelector("input");
  let discountPending = false, attemptedCode = "";
  const discountCopy = (en, zh) => document.documentElement.lang.startsWith("zh") ? zh : en;
  const sameDiscount = (a, b) => typeof a === "string" && typeof b === "string" && a.trim().toUpperCase() === b.trim().toUpperCase();
  const discountApplications = cart => [
    ...(cart.cart_level_discount_applications || []),
    ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || item.discount_allocations || []).map(allocation => ({ ...allocation.discount_application, total_allocated_amount: allocation.amount })))
  ];
  function discountFeedback(state, message) {
    const targets = [codeForm?.closest(".discount-form"), document.querySelector(".gift-wallet"), document.querySelector(".gift-dialog")].filter(Boolean);
    targets.forEach(target => {
      let status = target.querySelector("[data-cart-discount-status]");
      if (!status) {
        status = document.createElement("p"); status.dataset.cartDiscountStatus = "";
        status.className = "cart-checkout-note"; status.setAttribute("role", "status"); status.setAttribute("aria-live", "polite");
        status.style.overflowWrap = "anywhere"; target.append(status);
      }
      status.dataset.state = state; status.textContent = message;
    });
  }
  function discountResult(cart) {
    const code = attemptedCode;
    if (!code) return;
    if (!cart.item_count) {
      discountFeedback("empty", discountCopy("Your cart is empty. Add an eligible item before checking this coupon.", "购物车为空，请先加入符合优惠条件的商品，再应用优惠券。")); return;
    }
    const entry = cart.discount_codes?.find(item => sameDiscount(item.code, code));
    const allocated = discountApplications(cart).filter(item => sameDiscount(item.code || item.title, code)).reduce((sum, item) => sum + Number(item.total_allocated_amount || 0), 0);
    if (entry?.applicable === false) {
      discountFeedback("pending", discountCopy(`${code} is not applicable to this cart yet. Check the offer conditions and confirm your account email at checkout.`, `${code} 暂未适用于当前购物车。请核对优惠条件，并在结账时确认账号邮箱。`));
    } else if (allocated > 0) {
      discountFeedback("applied", discountCopy(`${code} applied. Discount from this code: ${money(allocated)}.`, `${code} 已应用，本优惠码实际抵扣 ${money(allocated)}。`));
    } else if (entry?.applicable === true) {
      discountFeedback("pending", discountCopy(`${code} was added, but no item discount has been confirmed. Check the final discount at checkout.`, `${code} 已加入购物车，但尚未确认商品抵扣金额，请在结账页核实最终优惠。`));
    } else {
      discountFeedback("pending", discountCopy(`No discount for ${code} was confirmed. Check the offer conditions and the result at checkout.`, `尚未确认 ${code} 的抵扣，请核对优惠条件及结账页结果。`));
    }
  }
  function renderDiscountCart(cart) {
    const summary = document.querySelector(".cart-summary-native");
    if (summary) {
      const lines = summary.querySelectorAll(".summary-line");
      const subtotal = lines[0]?.querySelector("b"), discount = lines[1]?.querySelector("b"), total = summary.querySelector(".summary-total b");
      if (subtotal) subtotal.textContent = money(cart.original_total_price ?? cart.total_price);
      if (discount) discount.textContent = "−" + money(cart.total_discount);
      if (total) total.textContent = money(cart.total_price);
      summary.querySelectorAll(".cart-applied-discount").forEach(node => node.remove());
      const titles = [...new Set(discountApplications(cart).filter(item => Number(item.total_allocated_amount) > 0).map(item => item.title || item.code).filter(Boolean))];
      titles.forEach(title => { const label = document.createElement("p"); label.className = "cart-applied-discount"; label.textContent = title; lines[1]?.after(label); });
      const checkout = summary.querySelector("[name='checkout']"); if (checkout) checkout.disabled = !cart.item_count;
      document.querySelectorAll(".cart-item").forEach((row, index) => {
        const item = cart.items[index], amount = row.querySelector(":scope > strong");
        if (item && amount) amount.textContent = money(item.final_line_price);
      });
    }
    if (!discountPending) discountResult(cart);
  }
  async function applyDiscount(code) {
    if (discountPending) return;
    code = String(code || "").trim();
    if (!code || code.length > 255 || /[,\r\n]/.test(code)) {
      discountFeedback("error", discountCopy("Enter one discount code to apply.", "请输入一个优惠码后再应用。")); return;
    }
    attemptedCode = code; if (codeInput) codeInput.value = code;
    discountPending = true;
    const controls = [...document.querySelectorAll("[data-wallet-apply], [data-gift-action], [data-shopify-discount-form] button")];
    controls.forEach(control => control.setAttribute("aria-disabled", "true"));
    codeForm?.setAttribute("aria-busy", "true");
    discountFeedback("loading", discountCopy("Applying your coupon…", "正在应用优惠券…"));
    try {
      // Read the current cart before merging codes; keep any existing applicable offers.
      const response = await fetch(`${routes.cart}.js`, { headers: { Accept: "application/json" }, credentials: "same-origin" });
      if (!response.ok) throw new Error(discountCopy("The cart could not be checked. Please try again.", "暂时无法读取购物车，请重试。"));
      const current = await response.json();
      if (!Array.isArray(current.items)) throw new Error(discountCopy("The cart response could not be read. Please try again.", "无法读取购物车返回结果，请重试。"));
      if (!current.item_count) { applyCart(current); discountResult(current); return; }
      const codes = (current.discount_codes || []).filter(item => item.applicable === true).map(item => item.code);
      if (!codes.some(value => sameDiscount(value, code))) codes.push(code);
      const cart = await mutateCart(`${routes.root}cart/update.js`, { discount: codes.join(",") });
      discountResult(cart);
    } catch (error) {
      discountFeedback("error", error.message || discountCopy("The coupon could not be applied. Please try again.", "优惠券应用请求失败，请重试。"));
    } finally {
      discountPending = false;
      controls.forEach(control => control.removeAttribute("aria-disabled"));
      codeForm?.removeAttribute("aria-busy");
    }
  }
  codeForm?.addEventListener("submit", event => { event.preventDefault(); applyDiscount(codeInput?.value); });
  document.addEventListener("click", event => {
    const link = event.target.closest?.("[data-wallet-apply], [data-gift-action]");
    if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const coupon = window.CoolstarLoyalty?.usable(window.CoolstarAccount?.getState());
    if (!coupon || !link.getAttribute("href")) return;
    const href = new URL(link.href, location.origin);
    if (href.origin !== location.origin || !href.pathname.includes("/discount/")) return;
    event.preventDefault();
    if (codeForm) applyDiscount(coupon.code);
    else { const target = new URL(routes.cart, location.origin); target.searchParams.set("discount", coupon.code); location.href = target.href; }
  }, true);
  const productVariant = document.querySelector("#product-variant");
  productVariant?.addEventListener("change", () => {
    const selected = productVariant.selectedOptions[0];
    const price = document.querySelector("[data-product-price]");
    const compare = document.querySelector("[data-compare-price]");
    if (price && selected.dataset.price) price.textContent = selected.dataset.price;
    if (compare) {
      const showCompare = Boolean(selected.dataset.comparePrice) && selected.dataset.comparePrice !== selected.dataset.price;
      compare.hidden = !showCompare;
      if (showCompare) compare.textContent = selected.dataset.comparePrice;
    }
    if (selected.dataset.image) {
      const image = document.querySelector(".product-main-image img");
      if (image) image.src = selected.dataset.image;
    }
  });
  document.querySelectorAll(".product-thumbnails a").forEach(link => link.addEventListener("click", event => { event.preventDefault(); document.querySelector(".product-main-image img").src = link.href; }));
  const incomingDiscount = new URLSearchParams(location.search).get("discount");
  if (codeForm && incomingDiscount) applyDiscount(incomingDiscount);
  else syncCart();
})();
